import { render, staticRenderFns } from "./change-installation-owner-dialog.vue?vue&type=template&id=681d8972"
import script from "./change-installation-owner-dialog.vue?vue&type=script&lang=js"
export * from "./change-installation-owner-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('681d8972')) {
      api.createRecord('681d8972', component.options)
    } else {
      api.reload('681d8972', component.options)
    }
    module.hot.accept("./change-installation-owner-dialog.vue?vue&type=template&id=681d8972", function () {
      api.rerender('681d8972', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/modules/installation/components/change-installation-owner-dialog.vue"
export default component.exports